import React, { createContext, useState, useEffect, useRef, useCallback } from 'react';
import { useMsal } from "@azure/msal-react";
import { EventType } from "@azure/msal-browser";
// AuthContext.js
export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { instance } = useMsal();
  const [loading, setLoading] = useState(true);
  const tokenRef = useRef(null);
  const configRef = useRef(null);

  const init = useCallback(async () => {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) return;

    try {
      if (!configRef.current) {
        const configRes = await fetch("/api/config");
        configRef.current = await configRes.json();
      }

      const scope = configRef.current.SP_API_ENDPOINT;
      const response = await instance.acquireTokenSilent({
        scopes: [scope],
        account: accounts[0],
      });

      tokenRef.current = {
        token: response.accessToken,
        expiresAt: response.expiresOn.getTime() - 5 * 60 * 1000,
      };

      setLoading(false);
    } catch (err) {
      console.error("Erreur AuthContext init:", err);
    }
  }, [instance]);

  useEffect(() => {
    init();

    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === EventType.HANDLE_REDIRECT_END) {
        console.log("Redirect terminé, réinitialisation MSAL");
        init();
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance, init]);

  const getToken = async () => {
    const now = Date.now();
    const account = instance.getAllAccounts()[0];
    if (!account) throw new Error("No signed-in account");

    if (tokenRef.current && tokenRef.current.expiresAt > now) {
      return tokenRef.current.token;
    }

    if (!configRef.current) {
      const configRes = await fetch("/api/config");
      configRef.current = await configRes.json();
    }

    const scope = configRef.current.SP_API_ENDPOINT;
    const response = await instance.acquireTokenSilent({
      scopes: [scope],
      account,
    });

    tokenRef.current = {
      token: response.accessToken,
      expiresAt: response.expiresOn.getTime() - 5 * 60 * 1000,
    };

    return response.accessToken;
  };

  return (
    <AuthContext.Provider value={{ getToken, loading, account: instance.getAllAccounts()[0] }}>
      {children}
    </AuthContext.Provider>
  );
}